module.exports = __webpack_public_path__ + "static/me-998b790fc284c80ef88e5f27a7a22b32.png";